#import "../fragments/account-hierarchy-fragment.graphql"

mutation SetAccountParent($input: AccountParentSetInput!) {
    accountParentSet(input: $input) {
        account {
            ...AccountHierarchyFragment
        }
        parentAccount {
            ...AccountHierarchyFragment
        }
    }
}
